/**
 * Created by eriksundqvist on 24/05/16.
 */
import { connect } from 'react-redux';
import {
  setCustomerId,
  setCustomerEntity,
  setSendToEmail,
  setSendToEmailSecondary,
  setCompanyPhone,
  setMessageType,
  setEinvoiceAddress,
  setPoNumber
} from 'redux/modules/invoice/index';
import PickCustomer from './pick-customer';

function mapStateToProps (state) {
  return {
    customerEntity: state.invoice.customerEntity,
    customerId: state.invoice.customerId,
    submitted: state.invoice.submitted,
    user: state.user
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCustomerId: (customerId) => dispatch(setCustomerId(customerId)),
    setCustomerEntity: (customerEntity) => dispatch(setCustomerEntity(customerEntity)),
    setSendToEmail: (email) => dispatch(setSendToEmail(email)),
    setSendToEmailSecondary: (email) => dispatch(setSendToEmailSecondary(email)),
    setCompanyPhone: (companyPhone) => dispatch(setCompanyPhone(companyPhone)),
    setMessageType: (messageType) => dispatch(setMessageType(messageType)),
    setEinvoiceAddress: (eInvoiceAddress) => dispatch(setEinvoiceAddress(eInvoiceAddress)),
    setPoNumber: (poNumber) => dispatch(setPoNumber(poNumber))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PickCustomer);



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/customer/pick-customer-container.js
 **/